import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { endpoint } from './constants';
import { ApiResponse } from 'app/types-shared';
import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';
import { NewFolderData, MoveReportData, BookmarkReportData } from 'app/area/saved-reports/types';

export const api = {
  saveReport: async (data: any): Promise<any> => {
    const response = await new RemoteData(endpoint.saveReport).resource<any>().create(data, false);

    return await response;
  },
  loadSavedReports: async (reportCategory?: number[]): Promise<any> => {
    const response = await new RemoteData(endpoint.loadSavedReports)
      .resource<ApiResponse<CodetableWireFormat[]>>()
      .filter({reportCategory: reportCategory ?? null})
      .all();
    return response.data;
  },
  removeReport: async (id:number, unshare?:boolean): Promise<any> => {
    await new RemoteData(endpoint.removeReport(id))
      .resource<void>()
      .filter({unshare: unshare})
      .httpDelete({});
  },
  saveFolder: async (data: NewFolderData): Promise<any> => {
    const response = await new RemoteData(endpoint.saveFolder).resource<any>().create(data, false);
    const json = await response.json();

    return json.data;
  },
  updateFolder: async (data: any, folderId:number): Promise<any> => {
    const response = await new RemoteData(endpoint.updateFolder(folderId))
      .resource<any>()
      .save(data);

    return await response;
  },
  moveReport: async (id:number, data:MoveReportData): Promise<any> => {
    await new RemoteData(endpoint.moveReport(id))
      .resource<void>()
      .save(data);
  },
  searchRequiredUsers: async (): Promise<boolean> => {
    const response = await new RemoteData(endpoint.loadUsersMetadata).resource<ApiResponse<{ searchRequired: boolean }>>().single();   
    
    return response.data.searchRequired;
  },
  loadBookmarkedSavedReports: async (reportCategory?: number[]): Promise<any> => {
    const response = await new RemoteData(endpoint.loadBookmarkedSavedReports)
      .resource<ApiResponse<CodetableWireFormat[]>>()
      .filter({reportCategory: reportCategory ?? null})
      .all();
    return response.data;
  },
  removeBookmark: async (favouriteId: number): Promise<any> => {
    await new RemoteData(endpoint.manageBookmark(favouriteId))
      .resource<void>()
      .httpDelete({});
  },
  bookmarkReport: async (favouriteId: number, data: BookmarkReportData): Promise<any> => {
    await new RemoteData(endpoint.manageBookmark(favouriteId)).resource<any>().create(data, false);
  }

};
